export const portfolioData = {
  profile: {
    name: "Synthe",
    fullName: "Jeff N.",
    tagline: "Tech-savvy • Creative • Dog Lover • Sour Candy Fueled",
    location: "Pacific Northwest / Mountain View",
    amazonPersonaQuote: "Tech-savvy, creative, dog-loving, sour-candy-obsessed person who keeps a tidy home and stays fueled for your next project.",
    about: "Developer, maker, and creative builder. I build sleek web apps, configure tidy smart home automation systems, and turn ideas into working projects — usually with a dog by my side and a stash of sour candy nearby.",
    statusPill: {
      active: true,
      text: "Building next project",
      subtext: "Powered by Sour Patch Kids & Celcius",
    },
    socials: {
      github: "https://github.com/synthe",
      instagram: "https://www.instagram.com/djsynthe",
      tiktok: "https://www.tiktok.com/@synthe82",
      spotify: "https://open.spotify.com/user/djsynthe",
      linkedin: "https://www.linkedin.com/in/jeffrey-g-nelson/",
      email: "dj.synthe@gmail.com",
    }
  },

  copilot: {
    dogs: [
      {
        name: "Pierre Baguette",
        title: "Chief Morale Officer",
        breed: "French Bulldog",
        emoji: "🥖",
        traits: ["Desk Supervisor", "Baguette Energy", "Code Auditor"],
      },
      {
        name: "Leroy Beignet",
        title: "Co-Pilot & Treat Inspector",
        breed: "French Bulldog",
        emoji: "🍩",
        traits: ["Snore Symphony", "Beignet Boost", "Keyboard Guard"],
      }
    ],
    title: "Chief Morale Officers & Co-Pilots",
    breed: "French Bulldogs (The Frenchie Duo)",
    favoriteActivity: "Synchronized couch napping & desk supervision",
    moraleLevel: 200,
  },

  sourMeter: {
    favorite: "Sour Patch Kids (Blue Raspberry & Watermelon)",
    fuelLevel: 94,
    quote: "Warning: High acidity levels detected. Productivity boosted by 250%!",
  },

  techStack: [
    {
      category: "Frontend & Web",
      icon: "Code",
      skills: ["React", "JavaScript (ES6+)", "Vite", "Tailwind CSS", "HTML5/CSS3", "REST APIs"]
    },
    {
      category: "Systems & Tidy Setup",
      icon: "Cpu",
      skills: ["Node.js", "Git & GitHub", "Home Assistant", "Docker", "Linux Shell", "Smart Home Automation"]
    },
    {
      category: "Creative & Media",
      icon: "Sparkles",
      skills: ["UI/UX Design", "Web Audio API", "Digital Design", "Visual Editing", "Audio Synthesizers"]
    },
    {
      category: "Tidy Home & Workstation",
      icon: "Home",
      skills: ["Clean Cable Management", "Ergonomic Layouts", "Automated Lighting", "Minimalist Hardware"]
    }
  ],

  projects: [
    {
      id: "synthe-web",
      title: "Synthe Personal Hub",
      description: "Modern static web application hosted on GitHub Pages with custom domain integration, custom dark theme, and interactive persona widgets.",
      tags: ["React", "Vite", "Tailwind", "GitHub Pages"],
      category: "Web Apps",
      github: "https://github.com/synthe/synthe.github.io",
      demo: "https://djsynthe.com",
      featured: true,
      accent: "from-blue-600 to-amber-500",
    },
    {
      id: "tidy-home",
      title: "Tidy Home Automation System",
      description: "Custom Home Assistant dashboard managing ambient smart lighting, automated climate schedules, and organized sensor metrics.",
      tags: ["Home Assistant", "Zigbee", "Node-RED", "IoT"],
      category: "Smart Home",
      github: "https://github.com/synthe",
      featured: true,
      accent: "from-emerald-500 to-teal-700",
    },
    {
      id: "sour-fuel",
      title: "Sour Candy Energy Widget",
      description: "Interactive client-side canvas audio & visual widget measuring candy-fueled productivity spikes with custom particle bursts.",
      tags: ["JavaScript", "HTML5 Canvas", "Web Audio"],
      category: "Creative",
      github: "https://github.com/synthe",
      featured: true,
      accent: "from-yellow-400 to-pink-500",
    },
    {
      id: "dog-monitor",
      title: "Co-Pilot Cam & Morale Tracker",
      description: "Private camera dashboard and treat alert system to keep tabs on the dog while building projects in the studio.",
      tags: ["WebSockets", "React", "Python", "IoT"],
      category: "Smart Home",
      github: "https://github.com/synthe",
      featured: false,
      accent: "from-amber-600 to-orange-500",
    },
    {
      id: "mountain-audio",
      title: "Alpine Peak Audio Lab",
      description: "Browser-based sound design toy inspired by mountain peaks and retro synthesizer modulation controls.",
      tags: ["Web Audio API", "React", "SVG"],
      category: "Creative",
      github: "https://github.com/synthe",
      featured: false,
      accent: "from-indigo-600 to-purple-600",
    }
  ]
};
